module.exports = __webpack_public_path__ + "img/FR18129.3c654c22.png";